var React = require('react');

function LinkedinFooter (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M0 11C0 4.92487 4.92487 0 11 0V0C17.0751 0 22 4.92487 22 11V11C22 17.0751 17.0751 22 11 22V22C4.92487 22 0 17.0751 0 11V11ZM5.6375 9.14375V16.5H7.975V9.14375H5.6375ZM5.5 6.80625C5.5 7.5625 6.05 8.1125 6.80625 8.1125C7.5625 8.1125 8.1125 7.5625 8.1125 6.80625C8.1125 6.05 7.5625 5.5 6.80625 5.5C6.11875 5.5 5.5 6.05 5.5 6.80625ZM14.1625 16.5H16.3625V11.9625C16.3625 9.69375 14.9875 8.9375 13.6812 8.9375C12.5125 8.9375 11.6875 9.69375 11.4812 10.175V9.14375H9.28125V16.5H11.6187V12.5813C11.6187 11.55 12.3062 11 12.9937 11C13.6812 11 14.1625 11.3438 14.1625 12.5125V16.5Z","fill":"currentColor"}));
}

LinkedinFooter.defaultProps = {"viewBox":"0 0 22 22","fill":"none"};

module.exports = LinkedinFooter;

LinkedinFooter.default = LinkedinFooter;
